<template>
    <div class="user">
        <!--搜索表单-->
        <div class="common-seach-wrap">
            <div class="common-seach-wrap">
                <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item>
                        <el-select v-model="searchForm.flow_type" clearable placeholder="类型">
                            <el-option label="购入产品" value="TokenOut"></el-option>
                            <el-option label="健康币卖出" value="TokenVanish"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker
                            v-model="searchForm.create_time"
                            size="small"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" icon="el-icon-search" @click="searchSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="table-wrap">
            <el-table v-loading="loading" :data="tableData" style="width: 100%">
                <el-table-column prop="activity_coin_id" label="ID" width="50"></el-table-column>
                <el-table-column prop="flow_type" label="类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.flow_type == 'TokenOut'" class="red">购入产品</span>
                        <span v-if="scope.row.flow_type == 'TokenVanish'" class="green">健康币卖出</span>
                    </template>
                </el-table-column>
                <el-table-column prop="tokens_given" label="健康币数量"></el-table-column>
                <el-table-column prop="token_value" label="币值"></el-table-column>
                <el-table-column prop="order_no" label="订单号" width="150"></el-table-column>
                <el-table-column prop="user" label="用户">
                    <template slot-scope="scope">
                        {{scope.row.user.nickName}}
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间"></el-table-column>

            </el-table>

            <!--分页-->
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import PlatformActivityApi from "@/api/platformactivity.js";
    export default {
        components: {
        },
        data() {
            return {
                /*表单数据*/
                tableData: [],
                loading: true,
                pageSize: 20,
                totalDataNumber: 0,
                curPage: 1,
                /*横向表单数据模型*/
                searchForm: {
                    flow_type: "",
                    create_time: ''
                },
            };
        },
        created() {
            /*获取平台活动列表*/
            this.getData()
        },
        methods: {
            /*搜索*/
            searchSubmit() {
                this.curPage = 1;
                this.getData();
            },
            /*获取平台活动列表*/
            getData () {
                let self = this
                let Params = self.searchForm
                Params.page = self.curPage
                Params.list_rows = self.pageSize

                self.loading = true
                PlatformActivityApi.coin.list(Params, true)
                    .then((data) => {
                        self.loading = false
                        self.tableData = data.data.list.data
                        self.totalDataNumber = data.data.list.total
                    })
                    .catch((error) => {
                        self.loading = false
                    })
            },

            /*选择第几页*/
            handleCurrentChange(val) {
                this.curPage = val;
                this.loading = true;
                this.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.getData();
            },


        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/platformactivity/coin/index.vue